export const HERO_CONSTANTS = {
  button: {
    label: "Gain Full Network Control",
    link: "#contact-us",
  },
  title: "Complete Network Visibility for Proactive Management",
};
